import React from 'react';
import { Button } from '@components';
import { Input, Typography } from 'gd-design-library';
import styles from './SignInForm.module.scss';
import classNames from 'classnames/bind';
import { formFields } from './form';
import { useForm } from 'hooks';
import Link from 'next/link';
import { ROUTES } from '@constants';

const CN = 'sign-in-form';
const fieldClassName = `${CN}--field`;
const textClassName = `${CN}--text`;
const buttonClassName = `${CN}--button`;
const signUpClassName = `${textClassName}--sign-up`;

const cx = classNames.bind(styles);

interface Props {
  onSignIn: (email: string, password: string) => Promise<void>;
  showSignUpLink?: boolean;
  isLoading: boolean;
  errorMessage?: string;
}

export const SignInForm: React.FC<Props> = ({ onSignIn, showSignUpLink = true, isLoading, errorMessage }) => {
  const {
    state,
    errors,
    handleChange,
    handleBlur,
    handleAutofill,
    handleFocus,
    getFormValidState
  } = useForm(formFields);

  return (
    <form className={ cx(CN) }>
      <Input
        required
        name='email'
        variant='email'
        label='Email'
        value={ state.email }
        className={ cx(fieldClassName) }
        onAnimationStart={ handleAutofill }
        onFocus={ handleFocus }
        onBlur={ handleBlur }
        onChange={ handleChange }
        color={ !!errorMessage || (errors.email.isTouched && !errors.email.isValid) ? 'error' : 'primary' }
        helperText={ errorMessage || (errors.email.isTouched && !errors.email.isValid ? errors.email.message : '') }
      />
      <Input
        required
        name='password'
        variant='password'
        label='Password'
        value={ state.password }
        className={ cx(fieldClassName) }
        onAnimationStart={ handleAutofill }
        onFocus={ handleFocus }
        onBlur={ handleBlur }
        onChange={ handleChange }
        color={ errors.password.isTouched && !errors.password.isValid ? 'error' : 'primary' }
        helperText={ errors.password.isTouched && !errors.password.isValid ? errors.password.message : '' }
        maxLength={ 20 }
      />
      <Button
        className={ cx(buttonClassName) }
        loading={ isLoading }
        onClick={ (): void => {
          if (getFormValidState()) {
            onSignIn(state.email, state.password);
          }
        } }
      >
        Sign In
      </Button>
      { showSignUpLink &&
        <Typography variant='h6' className={ cx(textClassName) }>
          Don&apos;t have an account?
          <span className={ cx(signUpClassName) }>
            <Link href={ ROUTES.signUp }>
              Sign Up
            </Link>
          </span>
        </Typography>
      }
    </form>
  );
};
